export const IconSend = (props) => {
  return (
    <svg
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="17" cy="17.4375" r="17" fill="#F12E11" />
      <path
        d="M22.6357 21.1076L24.3521 15.9583C25.8516 11.4599 26.6013 9.21072 25.414 8.02345C24.2268 6.83619 21.9776 7.58592 17.4792 9.08538L12.3299 10.8018C8.69923 12.012 6.88392 12.6171 6.36806 13.5045C5.87731 14.3486 5.87731 15.3912 6.36806 16.2353C6.88392 17.1227 8.69923 17.7278 12.3299 18.938C12.9128 19.1323 13.2043 19.2295 13.4479 19.3926C13.684 19.5506 13.8869 19.7535 14.0449 19.9896C14.208 20.2332 14.3052 20.5247 14.4995 21.1076C15.7097 24.7383 16.3148 26.5536 17.2022 27.0694C18.0463 27.5602 19.0889 27.5602 19.933 27.0694C20.8204 26.5536 21.4255 24.7383 22.6357 21.1076Z"
        fill="white"
        stroke="#F12E11"
        stroke-width="1.5"
      />
      <path
        d="M20.213 14.2857C20.5075 13.9945 20.5102 13.5196 20.2189 13.2251C19.9276 12.9306 19.4528 12.9279 19.1583 13.2192L20.213 14.2857ZM14.6641 19.7735L20.213 14.2857L19.1583 13.2192L13.6093 18.707L14.6641 19.7735Z"
        fill="#F12E11"
      />
    </svg>
  );
};
